import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useRef } from "react";

const RejectDialog = ({ open, onClose, onReject, data }) => {
  const reasonField = useRef(null);
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Reject Invoice</DialogTitle>
      <DialogContent>
        <DialogContentText>Enter rejection reason</DialogContentText>
        <TextField
          margin="normal"
          id="name"
          label="Rejection Reason"
          type="text"
          fullWidth
          variant="standard"
          inputRef={reasonField}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            const reason = reasonField?.current?.value;
            if (!reason?.length) return;
            onReject({ ...data, reason: reasonField?.current?.value });
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectDialog;
